var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBoxWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3333 3.66667H3.66667V12.3333H12.3333V3.66667ZM3.66667 3H3V3.66667V12.3333V13H3.66667H12.3333H13V12.3333V3.66667V3H12.3333H3.66667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9231 8H11.0769",
    stroke: "white",
    strokeWidth: 0.666667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.0769L8 4.92306",
    stroke: "white",
    strokeWidth: 0.666667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBoxWhite);
export default __webpack_public_path__ + "static/media/add-box-white.8dd2a7410e814a1bef5c6ff6eae9347e.svg";
export { ForwardRef as ReactComponent };